import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Users, Award, MapPin, Target } from 'lucide-react';

const AboutPreview = () => {
  const stats = [
    { icon: Users, label: 'Years of Experience', value: '10+', color: 'text-blue-600' },
    { icon: Award, label: 'Projects Completed', value: '500+', color: 'text-purple-600' },
    { icon: MapPin, label: 'Locations Served', value: 'Qatar-wide', color: 'text-green-600' }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-2xl p-8 border border-gray-200">
              <img
                src="/img4.jpg"
                alt="HVAC Installation"
                className="w-full h-80 object-cover rounded-xl shadow-lg"
              />
            </div>
            
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-gradient-to-r from-purple-600 to-blue-600 text-white p-6 rounded-xl shadow-xl">
              <div className="text-center">
                <Target size={24} className="mx-auto mb-2" />
                <div className="text-sm font-semibold">Precision. Performance. Perfection.</div>
              </div>
            </div>
          </div>
          
          {/* Content */}
          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center bg-purple-50 rounded-full px-4 py-2 border border-purple-200 mb-6">
              <span className="text-purple-700 font-medium text-sm">About Our Company</span>
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Qatar's Trusted <span className="text-purple-600">AC Experts</span>
            </h2>
            
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Nebula Trading & Technical Services is a Qatar-based company offering end-to-end 
              air conditioning and refrigeration solutions for commercial, industrial, and 
              residential clients.
            </p>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              With years of hands-on experience and a team of skilled technicians, we specialize 
              in keeping your cooling systems running smoothly with minimal downtime and maximum efficiency.
            </p>
            
            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mb-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center bg-gray-50 rounded-xl p-6 border border-gray-200">
                  <div className={`w-12 h-12 rounded-lg bg-white shadow-md flex items-center justify-center mx-auto mb-3 ${stat.color}`}>
                    <stat.icon size={20} />
                  </div>
                  <div className="text-2xl font-bold text-gray-900 mb-1">{stat.value}</div>
                  <div className="text-sm text-gray-600 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
            
            <Link
              to="/about"
              className="group inline-flex items-center text-purple-600 hover:text-purple-700 transition-colors duration-300 font-semibold"
            >
              <span className="text-lg">Learn More About Us</span>
              <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;